import React, { forwardRef, useMemo } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import Crunch42MappingForm from "./Crunch42MappingForm";

const Crunch42CredentialsForm = forwardRef((props, ref) => {
  const fields = useMemo(() => [
    {
      name: "apiEndPoint",
      label: "API Endpoint",
      rules: [urlRegexValidator],
    },
    {
      name: "token",
      label: "Token",
      required: true,
      type: FieldTypes.PASSWORD,
    },
  ], []);

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={Crunch42MappingForm}
      initialValue={{ apiEndPoint: 'https://platform.42crunch.com' }}
    />
  );
});

export default Crunch42CredentialsForm;
